import { useEffect, useState } from 'react';
import { fetchMedicationAndMedicalProblemsResults } from '../infrastructure/autocompleteResultsRepository';
import { AutocompleteResult } from '../infrastructure/autocompleteResultRepository.interface';

interface UseAutocompleteControlledInputReturnable {
  options: AutocompleteResult[];
  setSearchedValue: React.Dispatch<React.SetStateAction<string>>;
  autocompleteOptions: AutocompleteResult[];
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
}

export default function useAutocompleteControlledInput(
  endpoint: string
): UseAutocompleteControlledInputReturnable {
  const options: AutocompleteResult[] = [];

  const [searchedValue, setSearchedValue] = useState('');
  const [autocompleteOptions, setAutocompleteOptions] = useState<
    AutocompleteResult[]
  >([]);

  const [open, setOpen] = useState(false);

  const loading = open && options.length === 0;

  useEffect(() => {
    if (!loading) {
      return undefined;
    }

    fetchMedicationAndMedicalProblemsResults(endpoint, searchedValue)
      .then((response) => {
        setAutocompleteOptions(response.results ?? []);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [endpoint, loading, searchedValue]);

  return {
    options,
    setSearchedValue,
    autocompleteOptions,
    setOpen,
    loading
  };
}
